import React, { Component } from 'react';
import './Store--List--Item.css';

import Button from '../components/Button';

class ListItem extends Component {

  constructor(props) {
    super(props);

    this._goToStore = this._goToStore.bind(this);

    this.state = {
      item:this.props.store
    };

  }

  componentDidMount() {

    

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item:newProps.store
    })
  }

  render() {

      return (
          
        <div className="stores_list--item one-third column">
          <div className="logo" onClick={this._goToStore}>{this.state.item.logo_url ? <img src={this.state.item.logo_url} alt={this.state.item.name} /> : null }</div>
          <p>{this.state.item.name}<br />
          <a href={"//simplesto.re/"+this.state.item.permalink}>simplesto.re/{this.state.item.permalink}</a></p>
          {this.state.showOwnership ? <p style={{marginLeft:"auto"}}>
            {this.state.item.creator ? <label>Creator</label> : null}
            {this.state.item.owner ? <label>Owner</label> : null}
            {this.state.item.admin ? <label>Admin</label> : null}
          </p> : null }
          <p style={{fontSize:".75em"}}><a className="button" href={"//settings.reallysimplestore.com/"+this.state.item.permalink}>Manage →</a></p>
        </div>
        
      );
  
  }

  _goToStore() {
    window.location.href = "//settings.reallysimplestore.com/"+this.state.item.permalink;
  }

}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/Store--List--Item.js